import React from 'react';

const defaultFooterContext:Function = () => {};
const FooterContext = React.createContext(defaultFooterContext);

export default FooterContext;
